// Inlined so the prefixer has no runtime dependencies. See VENDORED.md.
//
// Upstream chain: css-in-js-utils/lib/hyphenateProperty (MIT, Robin Frischmann) was a
// one-line re-export of the `hyphenate-style-name` package (MIT, Andrey Popp). This is
// hyphenate-style-name@1.x verbatim, with the trivial wrapper collapsed away.
//
// Note this is NOT identical to styletron-engine-atomic's own
// src/hyphenate-style-name.ts, which is an independent re-derivation that differs in
// two ways: it lowercases the whole string rather than just the matched capitals, and
// it probes its cache with `in` rather than `hasOwnProperty` (so a property named
// `toString` or `constructor` resolves to the Object.prototype member). Keep them
// separate until the packages are deliberately merged.

var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase();
}

export default function hyphenateProperty(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name];
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName);
}
